import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import AppRoutes from "../config/AppRoutes";
import ApiConfig from "../config/ApiConfig";
import { getUserId } from "../util/storage/accessTokenStorage";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object, string } from "yup";
import PURCHASEIRQVeteranView from "../views/IrqVeteranView";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqVeteranPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            isVeteran: bool().required(),
          })}
        >
          <PURCHASEIRQVeteranView
            content={contentMap.RefinanceIrqVeteranPage}
            navigationsAway={customNavigationMap.RefinanceIrqVeteranPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqVeteranPage);
